import { provideAuthInitializer } from '@yoshu-lib/core/auth/auth-initializer.factory'

import { provideTrevesAuthService } from './config/auth-service.provider'
import { provideTrevesAuthStore } from './config/auth-store.provider'
import { provideEnvironment } from './config/environment.provider'

export const provideCore = () => [
  provideEnvironment(),
  provideAuthInitializer(),
  provideTrevesAuthService(),
  provideTrevesAuthStore()
]
